
import Vue from "vue";
import { Component } from "vue-property-decorator";
import ElementStudioWidthAdjustmentBarAdjustmentHandle from "./ElementStudioWidthAdjustmentBarAdjustmentHandle.vue";

@Component({
  components: { ElementStudioWidthAdjustmentBarAdjustmentHandle }
})
export default class ElementStudioWidthAdjustmentBar extends Vue {
  dragging(e: MouseEvent, lastMouseX: number) {
    // -1 to move to the opposite side (it does make sense)
    this.$emit("change", -1 * (e.clientX - lastMouseX));
  }
}
